var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.411 7H16v2H4.417l4.33 4.33-1.414 1.415-6.04-6.04a1 1 0 0 1 0-1.415l6.04-6.04 1.415 1.414L4.41 7z","fill":"currentColor"}));
}

ArrowLeftInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
